module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "slider"
  }, [_c('ul', {
    staticClass: "slides"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../img/galeriaFotos/resplendor1.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption center-align"
  }, [_c('h3', [_vm._v("Venha para Resplendor!")]), _vm._v(" "), _c('h5', {
    staticClass: "light grey-text text-lighten-3"
  }, [_vm._v("Você irá amar!")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../img/galeriaFotos/resplendor3.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption left-align"
  }, [_c('h3', [_vm._v("Ótimo!")]), _vm._v(" "), _c('h5', {
    staticClass: "light grey-text text-lighten-3"
  }, [_vm._v("Lugar de Descanso e Lazer!")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../img/galeriaFotos/resplendor2.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption left-align"
  }, [_c('h3', [_vm._v("Melhor Lugar!")]), _vm._v(" "), _c('h5', {
    staticClass: "light grey-text text-lighten-3"
  }, [_vm._v("Para sua estadia !")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 m6 l6"
  }, [_c('div', {
    staticClass: "card z-depth-2 hoverable"
  }, [_c('div', {
    staticClass: "card-image"
  }, [_c('img', {
    staticClass: "materialboxed",
    attrs: {
      "width": "416",
      "height": "192",
      "src": require("../../img/galeriaFotos/resplendor7.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "card-title"
  }, [_vm._v("Resplendor")])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('p', [_vm._v("Resplendor é um município brasileiro no interior do estado de Minas Gerais,\n                                Região Sudeste do país. Pertence à Mesorregião do Vale do Rio Doce e Microrregião\n                                de Aimorés e localiza-se a leste da capital do estado, distando desta\n                                cerca de 440 km.\n                            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col s12 m6 l6"
  }, [_c('div', {
    staticClass: "card z-depth-2 hoverable"
  }, [_c('div', {
    staticClass: "card-image"
  }, [_c('img', {
    staticClass: "materialboxed",
    attrs: {
      "width": "416",
      "height": "192",
      "src": require("../../img/galeriaFotos/resplendor5.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "card-title"
  }, [_vm._v("Os Krenak")])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('p', [_vm._v("Os Krenak pertencem ao grupo lingüístico Macro-Jê, falando uma língua\n                                denominada Borun. Por isso, entre eles, são denominados de Borun e os Borun\n                                do Watu são os Krenak de Resplendor, MG.\n                            ")]), _vm._v(" "), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 m6 l6"
  }, [_c('div', {
    staticClass: "card z-depth-2 hoverable"
  }, [_c('div', {
    staticClass: "card-image"
  }, [_c('img', {
    staticClass: "materialboxed",
    attrs: {
      "width": "416",
      "height": "192",
      "src": require("../../img/galeriaFotos/resplendor6.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "card-title"
  }, [_vm._v("Rio Doce")])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('p', [_vm._v("O rio Doce é um curso de água da Região Sudeste do Brasil, que banha os estados de\n                                Minas Gerais e Espírito Santo. Com cerca de 853 km de extensão, seu curso representa\n                                a mais importante bacia hidrográfica totalmente incluída na Região Sudeste.\n                            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col s12 m6 l6"
  }, [_c('div', {
    staticClass: "card z-depth-2 hoverable"
  }, [_c('div', {
    staticClass: "card-image"
  }, [_c('img', {
    staticClass: "materialboxed",
    attrs: {
      "width": "416",
      "height": "192",
      "src": require("../../img/galeriaFotos/resplendor4.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "card-title"
  }, [_vm._v("Cultura")])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('p', [_vm._v("\n                                Festa Rural de Resplendor, realizada desde 1983, contando com exposições, cavalgadas e\n                                shows musicais com bandas regionais ou conhecidas nacionalmente, sendo que em algumas\n                                edições atrai mais de 20 mil pessoas durante os dias do evento.\n                            ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 m6 l6"
  }, [_c('div', {
    staticClass: "card z-depth-2 hoverable"
  }, [_c('div', {
    staticClass: "card-image"
  }, [_c('img', {
    staticClass: "materialboxed",
    attrs: {
      "width": "416",
      "height": "192",
      "src": require("../../img/galeriaFotos/seta-saloes-01.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "card-title"
  }, [_vm._v("Sete Salões")])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('p', [_vm._v("O Parque Estadual Sete Salões é uma área bem conhecida na região por\n                                seus atrativos naturais, em especial a gruta arenítica, cujos salões\n                                podem ser percorridos e admirados em sua beleza!\n                            ")])])])])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1a08aea9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a08aea9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/resplendor/resplendor.vue
// module id = 79
// module chunks = 0